export function tooltip() {
  const basketContainers = document.querySelectorAll("[data-attach-tooltip]");

  basketContainers.forEach(container => {
    const tooltips = container.querySelectorAll("[data-basket-tooltip]");
    
    tooltips.forEach(tooltip => {
      new Tooltip(tooltip, {
        placement: "top",
        container
      });
    });
  });
}
